if (!customElements.get("shop-the-look-panel")) {
  class ShopTheLookPanel extends HTMLElement {
    constructor() {
      super();

      this.$overlay = this.querySelector(".shop-the-look-panel__overlay");
      this.$content = this.querySelector(".shop-the-look-panel__content");
      this.$contentMedia = this.querySelector(
        ".shop-the-look-panel__content__media"
      );
      this.$contentLoading = this.querySelector(
        ".shop-the-look-panel__content__loading"
      );
      this.$contentEmpty = this.querySelector(
        ".shop-the-look-panel__content__empty"
      );
      this.$info = this.querySelector(".shop-the-look-panel__info");

      this.$previousArrow = document.querySelector('shop-the-look-previous button');
      this.$nextArrow = document.querySelector('shop-the-look-next button');
      this.isEnhanced = this.classList.contains('shop-the-look-panel-enhanced');

      // Assign events
      // -- Click
      this.addEventListener("click", (event) => {
        if (event.target) {
          // Close
          var $closeBtn = event.target.closest("[data-stl-close]");
          if (
            // Interacted directly with close button
            $closeBtn ||
            // Interacted with overlay
            event.target === this.$overlay
          ) {
            event.preventDefault();
            this.closePanel();
          }
        }
      });

      // -- Keypress
      this.addEventListener("keypress", (event) => {
        if (event.key === "Escape") {
          event.preventDefault();
          this.closePanel();
        }
      }); 

      // -- Window size change
      if (this.isEnhanced) {
        window.addEventListener("resize", (event) => {
          this.setNavHeight();
        });
      }
    }

    get $carousel() {
      return this.$content.querySelector("media-carousel");
    }

    showPanel() {
      this.classList.add("reveal");
      document.body.classList.add("modal-open");
      this.focus();
    }

    closePanel() {
      this.classList.remove("reveal");
      document.body.classList.remove("modal-open");
      this.blur();
    }

    setLoading() {
      this.$contentLoading.setAttribute("aria-hidden", false);
      this.$contentLoading.classList.remove("d-none");
      this.unsetEmpty();
    }

    unsetLoading() {
      this.$contentLoading.setAttribute("aria-hidden", true);
      this.$contentLoading.classList.add("d-none");
    }

    setEmpty() {
      this.$contentEmpty.setAttribute("aria-hidden", false);
      this.$contentEmpty.classList.remove("d-none");
      this.$contentMedia.innerHTML = "";
      this.$info.innerHTML = "";
      this.unsetLoading();
    }

    unsetEmpty() {
      this.$contentEmpty.setAttribute("aria-hidden", true);
      this.$contentEmpty.classList.add("d-none");
    }

    updateProductDetails() {
      const $productDetails = this.$carousel?.slider.slides[
        this.$carousel?.slider.track.details.rel
      ]
        ?.querySelector("template")
        ?.content.firstElementChild.cloneNode(true);

      if (this.$info && $productDetails) {
        this.$info.innerHTML = $productDetails.innerHTML;
      }
      if (this.isEnhanced) {
        this.setNavHeight();
      }
    }

    setNavHeight() {
      const imgHeight = document.querySelector('.shop-the-look-panel__main-img img').offsetHeight;
      if (imgHeight) {
        if (this.$previousArrow) {this.$previousArrow.style.top = (imgHeight / 2) - 23 + "px";}
        if (this.$nextArrow) {this.$nextArrow.style.top = (imgHeight / 2) - 23 + "px";}
      }
    }

    loadCollection(url) {
      const collectionUrl = new URL(
        url,
        url.startsWith("/") ? window.location.origin : undefined
      );

      if (this.isEnhanced) {
        collectionUrl.searchParams.append("view", "stl_content_enhanced");
      } else {
        collectionUrl.searchParams.append("view", "stl_content");
      }

      this.showPanel();
      this.setLoading();
      fetch(collectionUrl, {
        method: "GET",
      })
        .then((res) => res.text())
        .then((html) => {
          this.$contentMedia.innerHTML = html;
          if (this.$carousel) {
            this.unsetEmpty();
            this.$carousel.slider.on("slideChanged", () => {
              this.updateProductDetails();
            });
            this.updateProductDetails();
            this.unsetLoading();
          } else {
            this.setEmpty();
          }
        })
        .catch(() => {
          this.setEmpty();
        });
    }
  }
  customElements.define("shop-the-look-panel", ShopTheLookPanel);

  const toggleShopTheLookPanel = (event) => {
    if (event.target) {
      /**
       * Open the Shop the Look Panel when clicking on a link
       * that has the class .collection--stl-collection--link
       */
      const $target = event.target.closest(".collection--stl-collection--link.original");
      if ($target) {
        event.preventDefault();
        const $stl = document.querySelector("shop-the-look-panel");
        if ($stl) $stl.loadCollection($target.getAttribute("href"));
        return;
      }
    }
  };

  document.addEventListener("click", toggleShopTheLookPanel);


  class ShopTheLookControl extends HTMLElement {
    constructor() {
      super();
      this.cardActiveIndex = '';
      this.panelContent = document.getElementById('ShopTheLookPanel-Content');
      this.shopTheLookLinks = this.querySelectorAll('.collection--stl-collection--link');
      this.shopTheLookPrevious = document.querySelector('shop-the-look-previous');
      this.shopTheLookNext = document.querySelector('shop-the-look-next');

      this.shopTheLookLinks.forEach(
        (card) => card.addEventListener('click', this.cardClick.bind(this))
      );
      this.shopTheLookPrevious.addEventListener('click', this.cardPrevious.bind(this));
      this.shopTheLookNext.addEventListener('click', this.cardNext.bind(this));   
    }

    cardClick(event) {
      event.preventDefault();
      const $target = event.target.closest('.collection--stl-collection--link');
      if ($target) {
        this.cardActiveIndex = $target.getAttribute('data-card-index') * 1;
        const $stl = document.querySelector('shop-the-look-panel');
        if ($stl) $stl.loadCollection($target.getAttribute('href'));
        return;
      }
    }

    cardNext(event) {
      event.preventDefault();
      let newCardIndex = this.cardActiveIndex + 1;
      if (newCardIndex == this.shopTheLookLinks.length) {
        newCardIndex = 0;
      }
      let newCard = this.querySelector('.collection--stl-collection--link[data-card-index="'+newCardIndex+'"]');
      if (newCard) {
        this.cardActiveIndex = newCard.getAttribute('data-card-index') * 1;
        const $stl = document.querySelector('shop-the-look-panel');
        if ($stl) $stl.loadCollection(newCard.getAttribute('href'));
        return;
      }
    }

    cardPrevious(event) {
      event.preventDefault();
      let newCardIndex = this.cardActiveIndex - 1;
      if (newCardIndex < 0) {
        newCardIndex = this.shopTheLookLinks.length - 1;
      }
      let newCard = this.querySelector('.collection--stl-collection--link[data-card-index="'+newCardIndex+'"]');
      if (newCard) {
        this.cardActiveIndex = newCard.getAttribute('data-card-index') * 1;
        const $stl = document.querySelector('shop-the-look-panel');
        if ($stl) $stl.loadCollection(newCard.getAttribute('href'));
        return;
      }
    }
  }
  customElements.define("shop-the-look-control", ShopTheLookControl);

  
}
